import React, { useState } from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const ChartSection = ({ dailyData, isSubUser = false }) => {
  const [chartType, setChartType] = useState('sessions');

  const sessionsChartData = {
    labels: dailyData.dates,
    datasets: isSubUser ? [
      {
        label: 'Total Sessions',
        data: dailyData.totalSessions,
        borderColor: 'rgb(59, 130, 246)', // Blue
        backgroundColor: 'rgba(59, 130, 246, 0.5)',
        tension: 0.4,
        borderWidth: 2,
      }
    ] : [
      {
        label: 'Total Sessions',
        data: dailyData.totalSessions,
        borderColor: 'rgb(59, 130, 246)', // Blue
        backgroundColor: 'rgba(59, 130, 246, 0.5)',
        tension: 0.4,
        borderWidth: 2,
      },
      {
        label: 'Real Conversations',
        data: dailyData.meaningfulSessions,
        borderColor: 'rgb(245, 158, 11)', // Amber
        backgroundColor: 'rgba(245, 158, 11, 0.5)',
        tension: 0.4,
        borderWidth: 2,
      },
    ],
  };

  const messagesChartData = {
    labels: dailyData.dates,
    datasets: isSubUser ? [
      {
        label: 'Total Messages',
        data: dailyData.totalMessages,
        borderColor: 'rgb(16, 185, 129)', // Green
        backgroundColor: 'rgba(16, 185, 129, 0.5)',
        tension: 0.4,
        borderWidth: 2,
      }
    ] : [
      {
        label: 'Total Messages',
        data: dailyData.totalMessages,
        borderColor: 'rgb(16, 185, 129)', // Green
        backgroundColor: 'rgba(16, 185, 129, 0.5)',
        tension: 0.4,
        borderWidth: 2,
      },
      {
        label: 'Messages in Conversations',
        data: dailyData.meaningfulMessages,
        borderColor: 'rgb(139, 92, 246)', // Purple
        backgroundColor: 'rgba(139, 92, 246, 0.5)',
        tension: 0.4,
        borderWidth: 2,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
        labels: {
          padding: 20,
          usePointStyle: true,
          pointStyle: 'circle',
        },
      },
      title: {
        display: true,
        text: chartType === 'sessions' 
          ? 'Daily Chat Sessions Overview' 
          : 'Daily Messages Overview',
        padding: {
          top: 10,
          bottom: 30,
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          stepSize: 1,
          padding: 10,
        },
        grid: {
          color: 'rgba(0, 0, 0, 0.1)',
        },
      },
      x: {
        grid: {
          display: false,
        },
        ticks: {
          padding: 10,
        },
      },
    },
  };

  return (
    <div className="bg-white rounded-lg shadow-md p-6 pl-2 pr-2 pb-2 py-2">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-semibold">Daily Statistics</h2>
        <select
          value={chartType}
          onChange={(e) => setChartType(e.target.value)}
          className="px-3 py-2 border rounded-md text-sm"
        >
          <option value="sessions">Chat Sessions</option>
          <option value="messages">Messages</option>
        </select>
      </div>
      <div className="w-full" style={{ height: 'calc(100vh - 500px)', minHeight: '400px', width: 'calc(100% - 20px)'}}>
        <Line
          options={options}
          data={chartType === 'sessions' ? sessionsChartData : messagesChartData}
        />
      </div>
    </div>
  );
};

export default ChartSection; 